import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function MarqueeTicker() {
  const {
    t
  } = useLanguage();
  const content = <div className="flex items-center gap-12 shrink-0 pr-12" data-id="element-130" data-mp="1jijfagtxmxvb">
      {t.marquee_items.map((item, index) => <span key={index} className="italic text-white/60 text-sm whitespace-nowrap" data-id="element-131" data-mp="1ydza4o2c6xsr" data-mpi={index}>
          {item} ·
        </span>)}
    </div>;
  return <div className="bg-black border-y border-white/10 py-4 overflow-hidden" data-id="element-132" data-mp="15sfxq35zzsc7">
      <div className="flex w-max animate-marquee" data-id="element-133" data-mp="10sjpfrq9pequ">
        {content}
        {content}
      </div>
    </div>;
}